import styled from "styled-components/macro";

import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import { motion } from "framer-motion";

import { usePaymentForm } from "../PaymentFormContext";

export default function Untouched() {
  const {
    state: {
      userInitial: { loginLevel: loginLevelInitial },
      paymentMethods,
    },
  } = usePaymentPage();
  const {
    state: { hasAmountURLParam },
  } = usePaymentForm();

  const isHappyPath =
    loginLevelInitial === "full" && paymentMethods?.length > 0;

  // prevents animating in if this is the first thing the user sees when on the page
  const isInitialPaymentMethodStep = hasAmountURLParam && !isHappyPath;

  return (
    <Wrapper
      initial={!isInitialPaymentMethodStep && { opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: "auto" }}
      exit={{ opacity: 0, height: 0 }}
    >
      <Inside
        initial={!isInitialPaymentMethodStep && { y: "-100%" }}
        animate={{ y: 0 }}
        exit={{ y: "-100%" }}
      >
        <Placeholder>Payment Method</Placeholder>
      </Inside>
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  height: auto;
`;

const Inside = styled(motion.div)``;

const Placeholder = styled.div`
  color: #828c8d;
  font-size: 20px;
  font-weight: 400;
`;
